import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { usePermissionsStore } from 'stores/index';
import { urls } from 'shared/entities/domain';
import { useTypedTranslation } from 'shared/entities/localization';
import { IconSize } from 'shared/entities/components/Icon';
import { BellIcon } from 'shared/newComponents/icons';
import Reference from 'shared/newComponents/Reference';

import User from './User';
import CabinetBalance from './CabinetBalance';

import './Right.modules.scss';

const Right: React.FC<{ className?: string }> = ({ className }) => {
  const permissionsStore = usePermissionsStore();
  const { t } = useTypedTranslation('newsPage');

  return (
    <div styleName="right" className={className}>
      {permissionsStore.canViewBilling && (
        <CabinetBalance styleName="right__balance" />
      )}
      <Link
        to={urls.NEWS.root}
        styleName="right__news"
        aria-label={t('headerNewsLabel')}
      >
        <Reference
          title={t('headerNewsLabel')}
          trigger={
            <div styleName="right__news-icon">
              <BellIcon iconSize={IconSize.XM} />
            </div>
          }
        />
      </Link>
      <User />
    </div>
  );
};

export default observer(Right);
